import { TFunction } from "i18next";

import { CounselorResponse } from "@/api";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";

/**
 * The role that decides the avatar colour: Supervisor outranks the base staff role. undefined when the
 * counselor holds neither, which renders in the neutral colour.
 */
export function primaryCounselorRole(roles: string[]): UserPermission | undefined {
  if (roles.includes(UserPermission.Supervisor)) {
    return UserPermission.Supervisor;
  }
  return roles.includes(UserPermission.SulStaff) ? UserPermission.SulStaff : undefined;
}

const ROLE_LABEL_KEYS: Partial<Record<string, "counselors.roles.supervisor" | "counselors.roles.counselor">> = {
  [UserPermission.Supervisor]: "counselors.roles.supervisor",
  [UserPermission.SulStaff]: "counselors.roles.counselor",
};

// A role this screen has no label for is shown by its raw name rather than hidden.
function counselorRoleLabel(role: string, t: TFunction): string {
  const labelKey = ROLE_LABEL_KEYS[role];
  return labelKey == null ? role : t(labelKey);
}

export function formatCounselorRoles(roles: string[], t: TFunction): string {
  return roles.map((role) => counselorRoleLabel(role, t)).join(", ");
}

export function formatListName(counselor: CounselorResponse): string {
  return `${counselor.lastName}, ${counselor.firstName}`;
}

export function formatFullName(counselor: CounselorResponse): string {
  return `${counselor.firstName} ${counselor.lastName}`.trim();
}
